<div *ngIf="editable; else formatedTime" class="form-group mb-0">
  <div class="input-w-datepicker input-group position-relative">
    <input
      class="input-w-datepicker__input form-control"
      [class.dp-input]="showTimeZone"
      [(ngModel)]="date"
      (ngModelChange)="updateDateTime()"
      name="dp"
      ngbDatepicker
      [placeholder]="placeholder || ''"
      [footerTemplate]="footerRef"
      [placement]="placement"
      [positionTarget]="buttonEl"
      [autoClose]="hideTimeOfDate"
      #datePicker="ngbDatepicker"
      [disabled]="!editable"
      [minDate]="minTime"
      [maxDate]="maxTime"
      readonly
      [id]="inputId"
    />
    <span *ngIf="showTimeZone" class="input-overlay-span">
      {{ getLocalTime(currentTime) }}
    </span>

    <div class="input-group-append" [class.hidden]="!editable">
      <button
        #buttonEl
        class="input-w-datepicker__btn btn btn-outline-secondary"
        (click)="datePicker.toggle()"
        type="button"
      >
        <em class="input-w-datepicker__icon fas fa-calendar-alt"></em>
      </button>
    </div>
  </div>
</div>

<ng-template #formatedTime>
  <span>{{ getLocalTime(currentTime) }}</span>
</ng-template>

<ng-template #footerRef>
  <div *ngIf="editable" class="datepicker__footer mt-1">
    <ngb-timepicker
      class="timepicker-custom align-self-center"
      *ngIf="!hideTimeOfDate"
      [(ngModel)]="time"
      (ngModelChange)="updateDateTime()"
      [meridian]="false"
      [disabled]="!editable"
    >
    </ngb-timepicker>

    <div class="form-group mt-2" *ngIf="showTimeZone">
      <label for="timezoneSelect">{{ 'Timezone' | translate }}</label>
      <div class="drpdown-timezone-wrapper">
        <select
          id="timezoneSelect"
          class="form-control timezone text--ellipsis text-truncate"
          [(ngModel)]="selectedTimezone.tzCode"
          (ngModelChange)="onTimezoneChange($event)"
        >
          <optgroup *ngFor="let group of timezoneGroups" [label]="group.offset">
            <option *ngFor="let tz of group.timezones" [value]="tz">
              {{ group.offset }} {{ tz }}
            </option>
          </optgroup>
        </select>
      </div>
    </div>

    <div class="datepicker__btn-group mt-2">
      <button
        *ngIf="isOptional"
        class="btn btn-outline-primary"
        (click)="clear()"
        type="button"
        translate
      >
        Clear
      </button>

      <ng-container *ngIf="!hideTimeOfDate">
        <button
          class="btn btn-outline-primary"
          (click)="cancel()"
          type="button"
          translate
        >
          Cancel
        </button>

        <button
          class="btn btn-primary"
          (click)="confirm()"
          type="button"
          translate
          [disabled]="!timeIsDifferent"
        >
          Ok
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>
